import {SET_DATA, setDataT} from "../reducers/DataState";


export const SetData = (data: setDataT['data']) => {
    return({
        type: SET_DATA,
        data: data
    })
}
